import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const ContainerForm = styled(Box)(
    ({ theme }: ParamsStyle) => `
        position: relative;
        display: grid;
        grid-auto-rows: auto 1fr;
        align-items: flex-start;
        padding: 0 1rem;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        border-top: 5px solid ${theme?.palette.secondary.main};

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 62%;
            padding: 0;
            border: none;
            align-items: center;
            border-left: 8px solid ${theme?.palette.secondary.main};
        }
`);